﻿import type { RouteRecordRaw } from 'vue-router'

const crmRoutes: RouteRecordRaw = {
  path: '/crm',
  name: 'CRM',
  redirect: '/crm/lead',
  meta: { title: 'CRM客户关系', icon: 'icon-customer-service' },
  children: [
    { path: 'lead', name: 'CrmLead', component: () => import('@/views/crm/LeadList.vue'), meta: { title: '销售线索', permissions: ['crm:lead:view'] } },
    { path: 'opportunity', name: 'CrmOpportunity', component: () => import('@/views/crm/OpportunityList.vue'), meta: { title: '商机管理', permissions: ['crm:opportunity:view'] } },
    { path: 'customer', name: 'CrmCustomer', component: () => import('@/views/crm/CustomerList.vue'), meta: { title: '客户档案', permissions: ['crm:customer:view'] } },
    { path: 'quotation', name: 'CrmQuotation', component: () => import('@/views/crm/QuotationList.vue'), meta: { title: '客户报价', permissions: ['crm:quotation:view'] } },
    { path: 'contract', name: 'CrmContract', component: () => import('@/views/crm/ContractList.vue'), meta: { title: '客户合同', permissions: ['crm:contract:view'] } },
    { path: 'visit', name: 'CrmVisit', component: () => import('@/views/crm/VisitList.vue'), meta: { title: '客户回访', permissions: ['crm:visit:view'] } },
  ],
}

export default crmRoutes
